export default __webpack_public_path__ + "static/media/bh-mount.84b40412.gif";